const { is } = require('../../is/is')

/**
 * Lebegőpontos number parse-olás.
 * @example
 * '42' → 42
 * '42.42' → 42.42
 * @param {string} value - Az érték, amit át kell parse-olni.
 * @param {number} [fallback=0] - Az érték, amit visszaad, ha a parse nem sikerül.
 * @returns {number} A parse-olt érték.
 */
module.exports.gokuParseFloat = function gokuParseFloat (value, fallback = 0) {
  // eslint-disable-next-line no-restricted-syntax
  const parsed = parseFloat(value)

  // Sikerült számot parse-olni.
  if (is.number(parsed)) {
    return parsed
  }

  return fallback
}
